import { useContext } from 'react'

import { AppReviewContext } from '@/contexts'

export const useAppReview = () => useContext(AppReviewContext)
